import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { Accordion } from "react-bootstrap";
import RentInvoice from './Invoice';
import { Tooltip as WmsTooltip } from "react-tooltip";
import CalculationInfo from './CalculationInfo';
import moment from 'moment';

/* istanbul ignore next */
const RentCalculator = () => {
    const { showAccountingMenu } = useSelector((state) => state.accountingReducer);
    const { id } = useParams();
    const navigate = useNavigate();
    const location = useLocation();
    const [showInvoiceDialog, setShowInvoiceDialog] = useState(false);
    const [showCalculations, setShowCalculations] = React.useState(false);
    const [isViewMode, _setIsViewMode] = useState(location.state?.isView || false);
    
    const [formData, setFormData] = useState({
        warehouse: '',
        company: '',
        seller: '',
        dateFrom: moment().format('YYYY-MM-DD'),
        dateTo: moment().format('YYYY-MM-DD'),
        categoryData: [
            { category: 'Inventory Products', volumeCFT: 9200, variableRate: 950.00 },
            { category: 'Inventory Packages', volumeCFT: 10000, variableRate: 1020.00 },
            { category: 'Return Products', volumeCFT: 8500, variableRate: 880.00 },
            { category: 'Return Packages', volumeCFT: 8000, variableRate: 1000.00 }
        ],
        baselineRate: 1833.33,
        variableRentRate: 3850.00,
        totalRent: 5683.33
    });

    useEffect(() => {
        if (id && id > 0) {
            // Load data for edit/view mode
            setFormData({
                ...formData,
                warehouse: 'Dallas WH-01',
                company: 'Acme Corp',
                seller: 'AcmeExports',
                dateFrom: '2025-11-01',
                dateTo: '2025-11-11'
            });
        }
    }, [id]);

    const handleBack = () => {
        navigate('/accounting/rent-list');
        setFormData({});
    };

    const showInvoiceDetails = () => {
        setShowInvoiceDialog(!showInvoiceDialog);
    };
    

    const handleShowCalculations = () => {
        setShowCalculations(!showCalculations);
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleCategoryChange = (index, field, value) => {
        const updatedCategories = [...formData.categoryData];
        // Remove commas and convert to number
        const cleanValue = value.replace(/,/g, '');
        const numericValue = field === 'volumeCFT' ? parseInt(cleanValue) || 0 : parseFloat(cleanValue) || 0;
        updatedCategories[index][field] = numericValue;
        setFormData({ ...formData, categoryData: updatedCategories });
    };

    const handleExport = () => {
        // Export logic
    };

    return (
        <div className={` ${showAccountingMenu ? 'col-10' : 'col-12'}`}>
            <div className="main__tile_heading cus-btn-include-sec">
                <span>
                    Rent Report
                </span>
                <div className="top_right_button_container">
                    <button
                        className="btn cus-seconday-bg-btn mr-2"
                        onClick={handleExport}
                    >
                        Export
                    </button>
                    <button
                        className="btn cus-primary-transparent-btn"
                        onClick={handleBack}
                    >
                        Back
                    </button>
                </div>
            </div>

            <div className="cus-page-content-sec">
                <div className="incomingAccordion accordion">
                    <div className="row fontFix">
                        <div className="col-lg-12">
                            <Accordion
                                defaultActiveKey={["0", "1", "2"]}
                                alwaysOpen={true}
                            >
                                <Accordion.Item eventKey="0">
                                    <Accordion.Header>
                                        General{" "}
                                        <i className="fa fa-chevron-down" aria-hidden="true"></i>
                                    </Accordion.Header>
                                    <Accordion.Body>
                                        <div className="row addressForm">
                                            <div className="col-lg-2 col-md-4 col-sm-6 mb-3">
                                                <label htmlFor="warehouse">Warehouse</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="warehouse"
                                                    name="warehouse"
                                                    value={formData.warehouse}
                                                    onChange={handleInputChange}
                                                    disabled
                                                />
                                            </div>
                                            <div className="col-lg-2 col-md-4 col-sm-6 mb-3">
                                                <label htmlFor="company">Company</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="company"
                                                    name="company"
                                                    value={formData.company}
                                                    onChange={handleInputChange}
                                                    disabled
                                                />
                                            </div>
                                            <div className="col-lg-2 col-md-4 col-sm-6 mb-3">
                                                <label htmlFor="seller">Seller</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="seller"
                                                    name="seller"
                                                    value={formData.seller}
                                                    onChange={handleInputChange}
                                                    disabled
                                                />
                                            </div>
                                            <div className="col-lg-3 col-md-6 col-sm-6 mb-3">
                                                <label htmlFor="dateFrom">Date From</label>
                                                <input
                                                    type="date"
                                                    className="form-control"
                                                    id="dateFrom"
                                                    name="dateFrom"
                                                    value={formData.dateFrom}
                                                    onChange={handleInputChange}
                                                />
                                            </div>
                                            <div className="col-lg-3 col-md-6 col-sm-6 mb-3">
                                                <label htmlFor="dateTo">Date To</label>
                                                <input
                                                    type="date"
                                                    className="form-control"
                                                    id="dateTo"
                                                    name="dateTo"
                                                    value={formData.dateTo}
                                                    onChange={handleInputChange}
                                                />
                                            </div>
                                        </div>
                                    </Accordion.Body>
                                </Accordion.Item>

                                <Accordion.Item eventKey="1">
                                    <Accordion.Header>
                                        Category Wise Variable Rent{" "}
                                        <i className="fa fa-chevron-down" aria-hidden="true"></i>
                                    </Accordion.Header>
                                    <Accordion.Body>
                                        <div className="table-responsive">
                                            <table className="table table-bordered">
                                                <thead>
                                                    <tr>
                                                        <th>Category</th>
                                                        <th>
                                                            Volume of Packages and Returns (CFT){" "}
                                                            <WmsTooltip
                                                                anchorId="volume-info"
                                                                content="Total cubic feet of packages and returns"
                                                                place="top"
                                                            />
                                                            <i
                                                                id="volume-info"
                                                                className="fa fa-info-circle ml-1"
                                                                aria-hidden="true"
                                                            ></i>
                                                        </th>
                                                        <th>
                                                            Variable Rent Rate (USD){" "}
                                                            <WmsTooltip
                                                                anchorId="rate-info"
                                                                content="Rate based on volume"
                                                                place="top"
                                                            />
                                                            <i
                                                                id="rate-info"
                                                                className="fa fa-info-circle ml-1"
                                                                aria-hidden="true"
                                                            ></i>
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {formData.categoryData.map((item, index) => (
                                                        <tr key={item.category}>
                                                            <td>{item.category}</td>
                                                            <td>
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    value={item.volumeCFT.toLocaleString()}
                                                                    onChange={(e) => handleCategoryChange(index, 'volumeCFT', e.target.value)}
                                                                    disabled={isViewMode}
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    value={item.variableRate.toFixed(2)}
                                                                    onChange={(e) => handleCategoryChange(index, 'variableRate', e.target.value)}
                                                                    disabled={isViewMode}
                                                                />
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </Accordion.Body>
                                </Accordion.Item>

                                <Accordion.Item eventKey="2">
                                    <Accordion.Header>
                                        Total Rent{" "}
                                        <i className="fa fa-chevron-down" aria-hidden="true"></i>
                                    </Accordion.Header>
                                    <Accordion.Body>
                                        <div className="row addressForm">
                                            <div className="col-lg-4 col-md-6 col-sm-12 mb-3">
                                                <label htmlFor="baselineRate">
                                                    Baseline (Fixed) Rent Rate{" "}
                                                    <WmsTooltip
                                                        anchorId="baseline-info"
                                                        content="Fixed monthly baseline rate"
                                                        place="top"
                                                    />
                                                    <i
                                                        id="baseline-info"
                                                        className="fa fa-info-circle ml-1"
                                                        aria-hidden="true"
                                                    ></i>
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="baselineRate"
                                                    name="baselineRate"
                                                    value={`USD ${formData.baselineRate.toFixed(2)}`}
                                                    onChange={(e) => {
                                                        const value = e.target.value.replace('USD ', '');
                                                        setFormData({ ...formData, baselineRate: parseFloat(value) || 0 });
                                                    }}
                                                    disabled={isViewMode}
                                                />
                                            </div>
                                            <div className="col-lg-4 col-md-6 col-sm-12 mb-3">
                                                <label htmlFor="variableRentRate">
                                                    Variable Rent Rate{" "}
                                                    <WmsTooltip
                                                        anchorId="variable-info"
                                                        content="Total variable rent based on volume"
                                                        place="top"
                                                    />
                                                    <i
                                                        id="variable-info"
                                                        className="fa fa-info-circle ml-1"
                                                        aria-hidden="true"
                                                    ></i>
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="variableRentRate"
                                                    name="variableRentRate"
                                                    value={`USD ${formData.variableRentRate.toFixed(2)}`}
                                                    onChange={(e) => {
                                                        const value = e.target.value.replace('USD ', '');
                                                        setFormData({ ...formData, variableRentRate: parseFloat(value) || 0 });
                                                    }}
                                                    disabled={isViewMode}
                                                />
                                            </div>
                                            <div className="col-lg-4 col-md-6 col-sm-12 mb-3">
                                                <label htmlFor="totalRent">Total Rent Rate</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="totalRent"
                                                    name="totalRent"
                                                    value={`USD ${formData.totalRent.toFixed(2)}`}
                                                    onChange={(e) => {
                                                        const value = e.target.value.replace('USD ', '');
                                                        setFormData({ ...formData, totalRent: parseFloat(value) || 0 });
                                                    }}
                                                    disabled={isViewMode}
                                                />
                                            </div>
                                        </div>
                                    </Accordion.Body>
                                </Accordion.Item>
                            </Accordion>
                        </div>
                    </div>
                </div>
            </div>

            <RentInvoice showModal={showInvoiceDialog} handleClose={showInvoiceDetails} />
            {showCalculations && (
                <CalculationInfo showModal={showCalculations} handleClose={handleShowCalculations} onHide={handleShowCalculations}/>
            )}
        </div>
    );
}

export default RentCalculator;